import React from 'react'
import Button from '../../../components/elements/button/Button'
import { cyberColors } from '../../../lib/colors'
import { SFXS } from '@orbitalgaming/games-frontend-library'

interface Close_props {
  handlePopup: (b: boolean) => void
  audio: any
}

export default function Close({ handlePopup, audio }: Close_props) {
  return (
    <Button
      width={'100%'}
      background={cyberColors.blueGradient}
      height={'34px'}
      size={'16px'}
      func={() => {
        !audio.isSoundOff && SFXS.goBackSFX.play(), handlePopup(false)
      }}
    >
      <p>close</p>
    </Button>
  )
}
